module.exports = __webpack_public_path__ + "img/yun-qi-da-log.f7ff49e0.jpg";